import { observer } from 'mobx-react-lite';
import 'mobx-react-lite/batchingForReactDom';
import React, { useState, useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { resolveModuleName } from 'typescript';
import { SimulcastTable } from '../../../elements';
import { useStores } from '../../../hooks';
import { schema } from './schema';

const ProductImagesHome = observer(
  ({ AuctionID, LaneID, MediaState, auctionName, laneName, uploadStatus }) => {
    // console.log('ProductImagesHome', {auctionName, uploadStatus, laneName})
    const {
      ProductImagesStore: {
        data,
        isLoading,
        loadProductImagesByAuction: dataByAuction,
        loadProductImagesByLane: dataByLane,
        totalItems,
        reloadProductImage,
      },
    } = useStores();
    const {
      bodySchema,
      debugging,
      headerSchema,
      tableSettings: {
        getMethods,
        initialSortColumn,
        pageSelectTitle,
        searchFields,
      },
    } = schema;
    const [reloadMessage, setReloadMessage] = useState();

    const lane = { fn: dataByLane, id: LaneID };
    const auction = { fn: dataByAuction, id: AuctionID };
    const methods = getMethods(lane, auction);

    //fn: (id) => reloadProductImage({ productMediaGalleryID: id, laneID: null, auctionID: null, forceReUploadOfSuccessfulItems: false }),/

    const productImagesStateObject = {
      args: ['productMediaGalleryID'],
      callback: (res) => res.reloadData(),
      fn: (id) => reloadProductImage({ productMediaGalleryID: id }),
      //await updateMemberState(id, enabled, member),
    };

    return (
      <SimulcastTable
        bodySchema={bodySchema}
        debugging={debugging}
        exportButton={{
          visible: data.length > 0,
          fileName: `ProductImagesReport-${auctionName}`,
          sheetName: `Product Images`,
          showLocation: ['top'],
        }}
        headerSchema={headerSchema}
        initialMediaState={MediaState}
        initialSortColumn={initialSortColumn}
        isLoading={isLoading}
        methods={methods}
        pageSelectTitle={pageSelectTitle}
        rowData={data}
        searchFields={searchFields}
        state={{ auctionName, laneName, productImagesStateObject, hasError: 1 }}
        totalItems={totalItems}
        paginationRowChildren={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '0px 10px',
            }}
          >
            <Button
              size="tiny"
              primary
              onClick={async () => {
                const res = await reloadProductImage({
                  laneID: LaneID,
                  auctionID: AuctionID,
                  forceReUploadOfSuccessfulItems: true,
                });
                setReloadMessage(res.result);
              }}
            >
              Reload ALL {methods.name === 'auction' ? 'Auction' : 'Lane'}{' '}
              Images
            </Button>
            <Button
              size="tiny"
              color="red"
              onClick={async () => {
                const res = await reloadProductImage({
                  laneID: LaneID,
                  auctionID: AuctionID,
                });
                setReloadMessage(res.result);
              }}
            >
              Reload {methods.name === 'auction' ? 'Auction' : 'Lane'} Images
              with Errors Only
            </Button>
            <div
              style={{
                color: reloadMessage?.success ? 'green' : 'red',
                fontSize: '1.2rem',
                padding: '0px 10px',
              }}
            >
              {reloadMessage?.message}
            </div>
          </div>
        }
      />
    );
  },
);

export default ProductImagesHome;
